import React, { useEffect, useState } from 'react';

import i18n from 'i18n-react';
import PropTypes from 'prop-types';

import LoginForm from 'components/LoginForm';
import StorageHandler from 'config/StorageHandler';

import { storageKeys } from 'config/settings.json';
import apple from 'assets/images/app_store.png';
import google from 'assets/images/google_play.png';
import { addClassById, removeClassById } from '../../helpers/helpers';
import getFeatureFlags from 'helpers/getFeatureFlags';
import { legacyRemCss } from 'helpers/legacyRem';

const MobileButtons = ({ appleStore, googlePlay }) => {
  if (!appleStore && !googlePlay) return null;

  return (
    <div className="button__container">
      <div className="buttons small">
        {appleStore && (
          <a href={appleStore} target="_blank" rel="noopener noreferrer">
            <img src={apple} alt="App store" />
          </a>
        )}
        {googlePlay && (
          <a href={googlePlay} rel="noopener noreferrer" target="_blank">
            <img src={google} alt="Google Play" />
          </a>
        )}
      </div>
    </div>
  );
};

const LoginView = (props) => {
  const [logo, setLogo] = useState(null);
  const [loginImage, setLoginImage] = useState(null);
  const [appleStore, setAppleStore] = useState(null);
  const [googlePlay, setGooglePlay] = useState(null);

  useEffect(() => {
    const getAppInfo = async () => {
      const appInfo = await StorageHandler.load(storageKeys.appInfo);
      if (appInfo) {
        const flags = await getFeatureFlags();

        setLogo(flags.login_logo_base ? appInfo.logo : appInfo.logoWide);
        setLoginImage(appInfo.loginImage);
        setAppleStore(appInfo.appleStore);
        setGooglePlay(appInfo.googlePlay);
      }
    };
    getAppInfo();
  }, []);

  // Manually adds a custom class to the #openWidget element for this view only, so that it can be targeted with (s)css as normal.
  useEffect(() => {
    const widgetID = 'openWidget';
    addClassById(widgetID, 'openWidget__button--loginView');
    return () => {
      // Clean up the class when the component unmounts
      removeClassById(widgetID, 'openWidget__button--loginView');
    };
  }, []);

  return (
    <div className="loginView" data-testid="login-view">
      <div
        className="loginView__bg"
        style={{
          backgroundImage: `linear-gradient(transparent,rgba(0,0,0,.7)), url(${loginImage})`,
        }}
      >
        <div className="loginView__bg--content">
          <div className="buttonWrapper">
            {(appleStore || googlePlay) && i18n.translate('loginScreen.version2.store')}
            <MobileButtons appleStore={appleStore} googlePlay={googlePlay} />
          </div>
          <div className="poweredBy">{i18n.translate('loginScreen.version2.powered')}</div>
          <img
            src="https://front.travpromobile.com/logos/logo_white.png"
            className="loginView__content--logo"
            alt="Logo"
          />
        </div>
      </div>
      <div className="loginView__content">
        <img src={logo} className="loginView__content--logo" alt="Logo" />
        <LoginForm path={props.match.path} />
      </div>
      <style>
        {`#openWidget { width: ${legacyRemCss(25)}; height: ${legacyRemCss(6)}; display: block; top: ${legacyRemCss(2)}; bottom: unset; right: ${legacyRemCss(2)}; border-radius: ${legacyRemCss(5)}; margin-right: ${legacyRemCss(0.5)}; border: 1px solid var(--primary-color);} #openWidget:after {display: none; }`}
      </style>

      {window.location.pathname.includes('mobile') && (
        <style>
          {`.loginView__content { display: block !important; } .buttonWrapper { display: none !important; }.loginView__bg--content { display: none; } .mt-1 { margin-top: ${legacyRemCss(2.5)} } input { font-size: 16px !important; } .loginView__content { width: 100% !important; opacity: 1 !important; } .buttonWrapper { display:none !important; } .loginView__content--logo { display: none !important; } .btnInverse { display: none !important; } .cookieConsent { display: none; bottom: ${legacyRemCss(4)}; } .register { display: none !important; } .loginView .loginView__bg .loginView__bg--content .buttonWrapper img { display: none !important; }  #openWidget { display: none !important; } .loginView__bg { display: none !important; } .loginView { display:block !important; }`}
        </style>
      )}
    </div>
  );
};

export default LoginView;

LoginView.propTypes = {
  match: PropTypes.shape({
    path: PropTypes.string.isRequired,
  }),
};

LoginView.defaultProps = {
  match: {
    path: '/login',
  },
};
